<template>
  <div>
    <div class="count_center">
      <img src="../../assets/images/userbg3.png" alt=""/>
    </div>
  </div>
</template>

<script>
import qs from "qs"
import navlistBus from "./components/navlistBus.js";
import {sendCustomerOperationRecord} from "../../assets/js/baseDataRuquest";

export default {
    data() {
      return {};
    },

    methods: {
      nextLogin() {
        let noSecretData = this.$route.query
        if (
          noSecretData.noSecret !== '1' ||
          noSecretData === undefined ||
          noSecretData.code === undefined ||
          noSecretData.password === undefined
        ) {
          return
        }
        let url = '/carrier/auth/noSecretLogin'
        let params = {
          password: noSecretData.password,
          username: noSecretData.code
        }
        let headers = {
          headers: { noSecret: noSecretData.noSecret }
        }
        const loading = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.axios
          .post(url, qs.stringify(params), headers)
          .then(res => {
            if (res.data.code == 200) {
              let Authorization = res.data.data;
              localStorage.setItem(
                "Authorization_lineSupplier",
                JSON.stringify(Authorization)
              );
              sessionStorage.setItem(
                "Authorization_lineSupplier",
                JSON.stringify(Authorization)
              );
              sendCustomerOperationRecord('登录', '登录')
              this.$store.commit('addUserdata', res.data.data)
              navlistBus.$emit("navlistToindex", res.data.data.authorities);
              this.$message({ message: "登录成功", type: "success" });
              loading.close();
            } else {
              this.$message.info(res.data.message)
              loading.close()
            }
          })
      }
    },
    created() {
    },
    mounted() {
      this.nextLogin()
    },
  };
</script>
<style scoped>
  .count_center {
    padding-top: 80px;
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/userCountshow.vue